import React from "react";
import { Form } from "react-bootstrap";

import { defaultDateTimeFormat } from "@lib/utils";

import { OrderHistoryProps } from "@LeagueManagement/Order/types/order";

const OrderHistory = ({
    order,
    orderNote,
    setOrderNote,
}: OrderHistoryProps): React.JSX.Element => {
    return (
        <>
            <h3>Order History</h3>
            <div className="orderHistory">
                {order.history !== null &&
                    order.history.map((h, idx) => {
                        return (
                            <div key={idx}>
                                <cite>
                                    {defaultDateTimeFormat.format(
                                        new Date(h.date),
                                    )}
                                </cite>
                                <blockquote>
                                    {h.message}
                                    <br />
                                </blockquote>
                            </div>
                        );
                    })}
                <Form.Control
                    as="textarea"
                    rows={3}
                    className="newNote"
                    placeholder="Add new order note..."
                    value={orderNote || ""}
                    onChange={e => setOrderNote(e.currentTarget.value)}
                />
            </div>
        </>
    );
};

export default OrderHistory;
